import {
  SEARCHING_ASSETS_REQUEST, SEARCHING_ASSETS_SUCCEEDED, SEARCHING_ASSETS_FAILED,
  INVALIDATE_ASSETS_SEARCH, GENERATE_ASSET_LINK_REQUEST, GENERATE_ASSET_LINK_SUCCEDDED,
  GENERATE_ASSET_LINK_FAILED, INVALIDATE_ASSET_LINK,
  FETCHING_FREQUENTLY_SHARED_ASSETS_REQUEST, FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEDDED, FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED, FETCHING_RECOMMENDED_ASSETS_REQUEST, FETCHING_RECOMMENDED_ASSETS_SUCCEEDED, FETCHING_RECOMMENDED_ASSETS_FAILED, INVALIDATE_RECOMMENDED_ASSETS,
  FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_REQUEST,
  FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_SUCCEEDED,
  FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_FAILED,
  INVALIDATE_MEETING_DETAILS
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  search: {
    searching: false,
    query: '',
    items: [],
    pagination: {
      current: -1,
      totalPages: 1
    }
  },
  links: {},
  multiSelect: false,
  frequentlyShared: [],
  recommendedAssets: []
}

const linkState = {
  generating: false
};

function assetsReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCHING_ASSETS_REQUEST:
      return {
        ...state,
        search: {
          ...state.search,
          searching: true,
          query: action.payload.query,
          invalidated: true
        }
      };

    case SEARCHING_ASSETS_SUCCEEDED:
      var response = action.payload.response;

      var items = [];
      if (response.currentPage == 0) {
        items = response.records;
      } else {
        items = [...state.search.items, ...response.records];
      }

      items = _.uniqBy(items, (a) => {
        return a.id;
      });

      return {
        ...state,
        search: {
          ...state.search,
          searching: false,
          invalidated: false,
          query: action.payload.query,
          items: items,
          pagination: {
            ...state.search.pagination,
            current: response.currentPage,
            totalPages: response.totalPages
          }
        }
      };

    case SEARCHING_ASSETS_FAILED:
      return {
        ...state,
        search:{
          ...state.search,
          searching: false,
          invalidated: false,
          query: action.payload.query,
          error: action.payload.error
        }
      }

    case INVALIDATE_ASSETS_SEARCH:
      return Object.assign({}, state, {
        ...state,
        search: {
          searching: false,
          query: '',
          items: [],
          pagination: {
            current: -1,
            totalPages: 1
          }
        }
      });
    case GENERATE_ASSET_LINK_REQUEST:
      var id = action.payload.asset.id;
      var link = state.links[id] || linkState;

      return {
        ...state,
        links: {
          ...state.links,
          [id]: {
            ...link,
            generating: true
          }
        }
      };

    case GENERATE_ASSET_LINK_SUCCEDDED:
      var id = action.payload.assetId;
      var response = action.payload.response;

      var link = state.links[id] || linkState;

      return {
        ...state,
        links: {
          ...state.links,
          [id]: {
            ...link,
            ...response,
            generating: false
          }
        }
      };

    case GENERATE_ASSET_LINK_FAILED:
      var id = action.payload.assetId;
      var error = action.payload.error;

      var link = state.links[id] || linkState;

      return {
        ...state,
        links: {
          ...state.links,
          [id]: {
            ...link,
            generating: false,
            error: error
          }
        }
      };

    case FETCHING_FREQUENTLY_SHARED_ASSETS_REQUEST:

      return {
        ...state,
        frequentlyShared: {
          loading: true,
          fetched: false,
        }
      }

    case FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEDDED:
      return{
        ...state,
        frequentlyShared: {
          loading: false,
          fetched: true,
          items: action.payload.response
        }
      }

    case FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED:
      return {
        ...state,
        frequentlyShared: {
          loading: false,
          fetched: false,
          items: []
        }
      }

    case FETCHING_RECOMMENDED_ASSETS_REQUEST:
      return{
        ...state,
        recommendedAssets: {
          loading: true,
          fetched: false,
        }
      }
    
    case FETCHING_RECOMMENDED_ASSETS_SUCCEEDED:
      const recommendedAssets = action.payload.response;

      return{
        ...state,
        recommendedAssets: {
          loading: false,
          fetched: true,
          items: recommendedAssets
        }
      }

    case FETCHING_RECOMMENDED_ASSETS_FAILED:
      return{
        ...state,
        recommendedAssets: {
          loading: false,
          fetched: false,
          items: [],
          error: action.payload.error
        }
      }
    case INVALIDATE_RECOMMENDED_ASSETS:
      return{
        ...state,
        recommendedAssets:{
          loading: false,
          items: []
        }
      }

    case FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_REQUEST:
      return{
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: true,
          fetched: false,
        }
      }

    case FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_SUCCEEDED: {
      const newRecommendedAssets = action.payload.response.assets || [];
      const existingRecommendedAssets = state.recommendedAssets.items || [];
      const allRecommendedAssets = _.uniqBy([...existingRecommendedAssets, ...newRecommendedAssets], (a) => a.id);

      return{
        ...state,
        recommendedAssets: {
          loading: false,
          fetched: true,
          items: allRecommendedAssets
        }
      }
    }

    case FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_FAILED: {
      return{
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: false,
          fetched: false,
          error: action.payload.error
        }
      }
    }

    case INVALIDATE_MEETING_DETAILS:
      return {
        ...state,
        recommendedAssets: {
          loading: false,
          fetched: false,
          items: []
        }
      }

    default:
      return state;
  }
}

export { assetsReducer };